import React from 'react';
import { Spin } from 'antd';

const PDFReader = ({ pdfUrl }) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
  }, [pdfUrl]);

  if (!pdfUrl) {
    return (
      <div style={{ width: '10R%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0' }}>
        <p>No PDF loaded.</p>
      </div>
    );
  }

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    console.error("Failed to load PDF from signed URL.");
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      {loading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.5)',
          zIndex: 2,
        }}>
          <Spin size="large" />
        </div>
      )}

      <object
        data={pdfUrl}
        type="application/pdf"
        width="100%"
        height="100%"
        onLoad={handleLoad}
        onError={handleError}
        style={{ zIndex: 1 }}
      >

        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          onLoad={handleLoad}
          onError={handleError}
          style={{ border: 'none', zIndex: 1 }}
          title="PDF Viewer"
        >
          <p>Your browser does not support embedded PDFs. You can <a href={pdfUrl}>download the PDF here</a>.</p>
        </iframe>
      </object>
    </div>
  );
};

export default PDFReader;